import React from 'react'

const Modal = ({ open, onClose, children }) => {
  if (!open) return null
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/10">
      <div className="relative bg-white rounded-[16px] shadow-2xl w-full max-w-3xl p-10 min-h-[400px] flex flex-col">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-2xl text-[#535862] hover:text-[#DE3C7D] focus:outline-none"
          aria-label="Close"
        >
          &times;
        </button>
        {children}
      </div>
    </div>
  )
}

export default Modal
